// client/src/utils/analyticsHelpers.js
import toastr from 'toastr'

/**
 * Helper functions for analytics operations.
 * These functions may have side effects (e.g., toastr notifications).
 */

/**
 * Get user information for display in popovers
 * @param {number|string} userId - User ID to look up
 * @param {Array} players - Array of player objects
 * @returns {Object} Object with title and content for popover
 */
export function getUserInfo(userId, players) {
  // Find player by user_id
  const player = players.find(
    (p) => p.user_id && p.user_id.toString() === userId.toString(),
  )

  if (!player) {
    return {
      title: `User ${userId}`,
      content: 'No player data available',
    }
  }

  // Build name
  const fullName = [player.first_name, player.last_name]
    .filter(Boolean)
    .join(' ')
    .trim()

  const title = fullName || `User ${userId}`
  const contentParts = []

  if (fullName) {
    contentParts.push(`<strong>Name:</strong> ${fullName}`)
  }
  if (player.email) {
    contentParts.push(`<strong>Email:</strong> ${player.email}`)
  }
  contentParts.push(`<strong>User ID:</strong> ${userId}`)

  return {
    title,
    content: contentParts.join('<br>'),
  }
}

/**
 * Copy text to clipboard with user feedback
 * @param {string} text - Text to copy
 */
export function copyToClipboard(text) {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      toastr.success('Copied to clipboard!')
    })
    .catch(() => {
      toastr.error('Failed to copy to clipboard')
    })
}
